import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { FormsUtilsService, MessageService } from '../../../../core';
import { pessoaTipoCadastro } from '../../pessoa-tipo-cadastro';
import { PessoaContato, } from '../pessoa-contato';
import { isContatoTipoCobranca, isContatoTipoEntrega, isContatoTipoPrincipal } from '../tipo';

@Component({
    selector: 'sgt-pessoa-contato-unico',
    templateUrl: './pessoa-contato-unico.component.html',
    styleUrls: ['./pessoa-contato-unico.component.less']
})
export class PessoaContatoUnicoComponent {
    /** Se pode editar os dados do form do contato da pessoa */
    @Input() canEdit = true;
    @Input() tipoContato: number;
    @Input() entity: PessoaContato;
    @Output() entityChange = new EventEmitter<PessoaContato>();
    // @Input() idRepresentante: number;
    @Input() tipoCadastro: number;
    @Input() telefoneRequired = true;
    @Input() celularRequired = false;
    @Input() emailRequired = false;
    @Input() permiteExcluir = true;
    @Input() exterior = false; // Se for um contato de uma pessoa do exterior

    @ViewChild('form') form: NgForm;

    constructor(private formsUtilsService: FormsUtilsService,
                private messageService: MessageService) { }


    // ngOnChanges(changes: SimpleChanges) {
    //     for (const propName in changes) {
    //         // Quando existir o contato
    //         if (propName === 'entity') {
    //             if (changes[propName].isFirstChange()) {
    //                 if (this.entity) {
    //                     this.carregarSubRegioesDaCidade(this.entity.cidade);

    //                     // Setando a UF da máscara da IE
    //                     if (this.entity.cidade) {
    //                         this.ufMascaraIe = this.entity.cidade.estado.uf;
    //                     }
    //                 }
    //             }
    //         } else if (propName === 'idRepresentante') {
    //             if (!changes[propName].isFirstChange()) {
    //                 if (this.entity) {
    //                     this.entity.idCidadeSubRegiao = null;
    //                     this.entity.idCidadeSubRegiaoBairro = null;
    //                     this.carregarSubRegioesDaCidade(this.entity.cidade);
    //                 }
    //             }
    //         }
    //     }
    // }

    /** Verifica se é o contato Principal */
    isContatoPrincipal(): boolean {
        return isContatoTipoPrincipal(this.tipoContato);
    }

    /** Verifica se é o contato de Cobrança */
    isContatoCobranca(): boolean {
        return isContatoTipoCobranca(this.tipoContato);
    }

    /** Verifica se é o contato de Entrega */
    isContatoEntrega(): boolean {
        return isContatoTipoEntrega(this.tipoContato);
    }

    /** Verifica se a pessoa é um cliente */
    isCliente(): boolean {
        return this.tipoCadastro && this.tipoCadastro === pessoaTipoCadastro.cliente;
    }

    /** Verifica se pode adicionar o contato quando o mesmo não estiver cadastrado */
    canInsert(): boolean {
        // Se não puder editar, então não pode adicionar o contato
        if (!this.canEdit) {
            return false;
        }

        return true;
    }

    /** Verifica se pode excluir o contato */
    canDelete(): boolean {
        // Se não puder editar, então não pode excluir o contato
        if (!this.canEdit) {
            return false;
        }

        return this.permiteExcluir;
    }

    // /** Verifica se a pessoa é um cliente */
    // isCliente(): boolean {
    //     return this.tipoCadastro && this.tipoCadastro === pessoaTipoCadastro.cliente;
    // }


    // /** Quando o CEP for encontrado, setamos os valores nos campos do contato */
    // onCepEncontrado(cep: Cep) {
    //     if (cep) {
    //         this.entity.logradouro = cep.logradouro;
    //         this.entity.bairro = cep.bairro;
    //         this.entity.complemento = cep.complemento;
    //         this.entity.idCidade = cep.cidade.id;
    //         this.entity.cidade = cep.cidade;
    //         this.carregarSubRegioesDaCidade(this.entity.cidade);
    //         this.ufMascaraIe = cep.cidade.estado.uf;
    //     }
    // }

    // /** Ao alterar a cidade no typeahead */
    // onTypeaheadChangeCidade(cidade: Cidade) {
    //     if (cidade) {
    //         this.entity.idCidade = cidade.id;
    //         this.ufMascaraIe = cidade.estado.uf;
    //     } else {
    //         this.entity.idCidade = null;
    //     }
    //     this.entity.idCidadeSubRegiao = null;
    //     this.entity.idCidadeSubRegiaoBairro = null;
    //     this.carregarSubRegioesDaCidade(cidade);
    // }

    insert() {
        this.entity = new PessoaContato(this.tipoContato);
        this.entityChange.emit(this.entity);
    }


    deleteClick() {
        this.messageService.confirm('Deseja realmente excluir este contato?', 'Confirme').then(result => {
            if (result) {
                this.delete();
            }
        });
    }

    delete() {
        this.entity = null;
        this.entityChange.emit(null);
    }

    /** Verifica se pode salvar o contato quando o mesmo não estiver cadastrado */
    canSave(): boolean {
        // Se não puder editar, então não pode salvar o contato
        if (!this.canEdit) {
            return false;
        }

        return true;
    }


     /** Verifica se o contato está válido */
    isValid(): boolean {
      // Se não puder salvar então retoramos como form válido para não dar erros de campos inválidos
      if (!this.canSave()) {
            return true;
        }

        this.formsUtilsService.makeAllFieldsDirty(this.form);
        if (!this.form.valid) {
            this.messageService.info('Para salvar é preciso informar corretamente o contato e todos os seus campos destacados em vermelho', 'Informação');
            return false;
        }
        return true;
    }

    /** Carrega as sub-regiões da cidade informada e representante */
    // private carregarSubRegioesDaCidade(cidade: Cidade) {
    //     this.subRegioes = [];
    //     if (!cidade) {
    //         return;
    //     }

    //     this.regiaoCidadeSubRegiaoHttpService.searchDisponiveisParaRepresentantes([this.idRepresentante], cidade.id)
    //         .subscribe(
    //             entities => {
    //                 this.subRegioes = entities;
    //                 this.carregarBairrosDaSubRegiao(this.entity.idCidadeSubRegiao);
    //             },
    //             (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as sub-regiões e bairros da cidade', error)
    //         );
    // }


    // /** Ao alterar a sub-região no select */
    // onChangeSubRegiao(id: number) {
    //     this.entity.idCidadeSubRegiaoBairro = null;
    //     this.carregarBairrosDaSubRegiao(id);
    // }

    // /** Carrega os bairros da sub-região informada */
    // private carregarBairrosDaSubRegiao(idCidadeSubRegiao: number) {
    //     this.bairros = [];
    //     if (!this.subRegioes) {
    //         return;
    //     }

    //     const subRegiaoAtual = this.subRegioes.find(subRegiao => subRegiao.id === idCidadeSubRegiao);
    //     if (subRegiaoAtual) {
    //         this.bairros = subRegiaoAtual.bairros;
    //     }
    // }
}
